:host {
    display: block;
}

.search-button {
    background-color: var(--bs-body-bg);
}
